import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAVIGATION_GROUPS } from '../config/navigation';
import { hasOps } from '../lib/auth';

export function Sidebar() {
  const { t } = useTranslation();
  const loc = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return loc.pathname === '/';
    return loc.pathname === path || loc.pathname.startsWith(path + '/');
  };

  return (
    <aside className="w-60 flex-shrink-0 border-r border-gray-200 bg-white h-full overflow-y-auto">
      {/* Logo */}
      <div className="px-5 py-4 border-b border-gray-100">
        <span className="text-lg font-bold text-gray-900 tracking-tight">DevCockpit</span>
      </div>

      {/* Navigation Groups */}
      <nav className="px-3 py-2">
        {NAVIGATION_GROUPS.map((group, gi) => (
          <div key={group.label} className={gi > 0 ? 'mt-4 pt-3 border-t border-gray-100' : ''}>
            {/* Group label */}
            <div className="px-3 mb-1.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
              {t(group.label, group.label)}
            </div>

            {/* Items */}
            <div className="flex flex-col gap-0.5">
              {group.items.map((item) => {
                if (item.opsOnly && !hasOps()) return null;
                const active = isActive(item.path);
                const Icon = item.icon;

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium transition-all duration-150
                      ${active
                        ? 'bg-blue-50 text-blue-700 border-l-[3px] border-blue-600 pl-[9px]'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-[3px] border-transparent pl-[9px]'
                      }`}
                  >
                    <Icon className={`w-4 h-4 flex-shrink-0 ${active ? 'text-blue-600' : 'text-gray-400'}`} />
                    {t(item.name, item.name)}
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
}
